import { memo, useEffect, useState } from "react";
import { Tab, Tabs } from "@mui/material";

import classNames from "common/class-names";

import { CategoryTabsProps, CategoryTab } from "dto/components/app-category-tab-dto";

const AppCategoryTab = ({ tabs, onSelect, customBorder, disabledTabs }: CategoryTabsProps) => {
	const [selectedTab, setSelectedTab] = useState<number>(0);

	const selectedIndex = tabs.findIndex((tab) => tab.indexKey === selectedTab);

	const onHandleTabSelect = (tab: CategoryTab) => {
		setSelectedTab(tab.indexKey ?? 0);

		if (onSelect) onSelect(tab);
	};

	const containerClassNames = classNames({
		"app-category-tab": true,
		"app-category-tab--custom-border": Boolean(customBorder),
	});

	useEffect(() => {
		if (tabs) setSelectedTab(0);
	}, [tabs]);

	return (
		<div className={containerClassNames}>
			<Tabs value={selectedIndex} variant="scrollable" scrollButtons="auto" aria-label="category tabs" className="category-tab" allowScrollButtonsMobile>
				{tabs.map((tab) => (
					<Tab key={tab.indexKey} disabled={disabledTabs} label={tab?.title} onClick={() => onHandleTabSelect(tab)} className="category-tab__item" />
				))}
			</Tabs>
		</div>
	);
};

export default memo(AppCategoryTab);
